export interface ISignInRequestData {
  email: string;
  password: string;
}

export interface IPhoneRequestOTPData {
  phone: string;
  code: number;
}

export interface IVerifyPhoneData extends IPhoneRequestOTPData {
  otp: string;
}

export interface ISignUpRequestData extends ISignInRequestData {}

export enum LandingKey {
  DIRECT_SU = 'direct_su',
  DIRECT_EM = 'direct_em',
  DIRECT_REG = 'direct_reg',
}
